import { FilterGroups } from 'features/filter/components/filter-groups'
import React, { FC } from 'react'
import styled, { useTheme } from 'styled-components'
import { Collapse } from 'ui/collapse'
import { ScrollableContainer } from 'ui/scrollable-container'

import { getProjectName } from '../../../lib/get-project-name'
import { FilterSection as FilterSectionType } from '../types'

type Props = {
  declaration: FilterSectionType
  sectionClosed?: boolean
  sectionClosedMobile?: boolean
  filterSectionsClosedMobile?: boolean
  hideCollapse: boolean
  isHideCollapseFilterSection?: boolean
  showCarsNextDealer: boolean
}

export const FilterSection: FC<Props> = React.memo(
  ({
    declaration,
    sectionClosed = false,
    showCarsNextDealer = false,
    sectionClosedMobile = false,
    hideCollapse,
    isHideCollapseFilterSection
  }) => {
    const { type, key, hasScrollbar, groups, title } = declaration

    const theme = useTheme()

    const FilterGroupsComponent = () => (
      <Wrapper
        style={
          hideCollapse || (key === 'labels' && isHideCollapseFilterSection)
            ? { paddingTop: getProjectName() === 'generic_v2' ? '0' : '15px' }
            : { paddingTop: 0 }
        }
        hideCollapse={hideCollapse}
      >
        <FilterGroups groups={groups} sectionType={type} sectionId={key} showCarsNextDealer={showCarsNextDealer} />
      </Wrapper>
    )

    const isCompactView = ['phone', 'phablet'].includes(theme.activeBreakpoint)

    return (
      <Container>
        <Collapse
          collapsed={isCompactView ? sectionClosed || sectionClosedMobile : sectionClosed}
          title={title}
          hideCollapse={hideCollapse}
          isHideCollapseFilterSection={isHideCollapseFilterSection}
          newVersion={false}
          isFilter
          isArrows
        >
          {hasScrollbar && !isCompactView ? (
            <ScrollableContainer maxHeight={'280px'}>
              <FilterGroupsComponent />
            </ScrollableContainer>
          ) : (
            <FilterGroupsComponent />
          )}
        </Collapse>
      </Container>
    )
  }
)

const Container = styled.div`
  border-bottom: ${({ theme }) => {
    if (getProjectName() === 'generic_v2') return '1px solid #2C2C2C'
    return getProjectName() !== 'tank' && `1px solid ${theme.palette.grey[200]}`
  }};
`

const Wrapper = styled.div<{ hideCollapse?: boolean }>`
  padding: ${({ theme }) => `${theme.spacing[0]} ${theme.spacing[4]} ${theme.spacing[4]}`};

  ${({ hideCollapse }) =>
    getProjectName() === 'generic_v2' &&
    `
      padding: 0 0 ${hideCollapse ? '10px' : '20px'};

      @media (min-width: 768px) {

      }
    `}
`
